import { useCallback } from "react";
import { Product } from "tm-shared/types";

import { FilterDrawerUI } from "@/domains/product";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setRejectProductsSelectedFilters } from "@/store/slices/ui";

type FilterValue = string | number | boolean;

interface RejectFilterDrawerProps<TProduct extends Product> {
    open: boolean;
    setOpen: (value: boolean) => void;
    products: Record<string, TProduct>;
    filteredProducts: TProduct[];
    availableFilters: Record<string, { title: string; options: FilterValue[] }>;
}

export function RejectFilterDrawer<TProduct extends Product>({
    open,
    setOpen,
    products,
    availableFilters,
    filteredProducts,
}: RejectFilterDrawerProps<TProduct>) {
    const dispatch = useAppDispatch();

    const { selectedFilters } = useAppSelector((s) => s.ui.rejectProducts);

    const onClose = () => setOpen(false);

    const handleResetFilters = () => {
        dispatch(setRejectProductsSelectedFilters(null));
        onClose();
    };

    const handleFilterChange = useCallback(
        (tag: string, values: (string | number | boolean)[]) => {
            dispatch(setRejectProductsSelectedFilters({ [tag]: values }));
        },
        [dispatch],
    );

    return (
        <FilterDrawerUI
            onClose={onClose}
            onApply={onClose}
            onReset={handleResetFilters}
            isOpen={open}
            products={products}
            availableFilters={availableFilters}
            selectedFilters={selectedFilters}
            onFilterChange={handleFilterChange}
            availableProductsLength={filteredProducts.length}
        />
    );
}
